import { Link } from 'react-router-dom';
import ContactForm from '@/pages/about/components/ContactForm';

const stats = [
  { value: '10,000+', label: '收录影视资源' },
  { value: '每日更新', label: '最新上线内容' },
  { value: '8 大类型', label: '多维度分类筛选' },
  { value: '24 / 7', label: '全天候访问' },
];

const team = [
  { name: '内容运营组', desc: '负责影视资源的整理、分类与专题策划，确保内容准确、更新及时。', icon: 'ri-stack-line' },
  { name: '产品体验组', desc: '打磨浏览、筛选与搜索体验，让找片变得更简单、更顺畅。', icon: 'ri-computer-line' },
  { name: '社区资讯组', desc: '追踪影视行业动态，撰写并筛选值得一看的资讯与观察。', icon: 'ri-newspaper-line' },
];

export default function About() {
  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6">
      <nav className="mb-4 flex items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">关于我们</span>
      </nav>

      <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-10">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">关于樱花视频</h1>
        <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
          樱花视频是一个专注影视内容的综合平台。我们希望用清晰友好的方式，帮助每一位影视爱好者快速找到想看的电影与电视剧，
          同时获取最新、最有价值的影视资讯。无论是重温经典，还是追更热播，樱花视频都愿成为你观影路上的好伙伴。
        </p>
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-200 bg-background-100 p-4 text-center">
              <p className="font-heading text-2xl font-bold text-primary-600">{s.value}</p>
              <p className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="flex flex-col gap-8 lg:col-span-2">
          <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-team-line text-primary-500"></i> 团队简介
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              我们是一支热爱影视、也热爱产品的小团队，始终把「让用户更快找到好内容」放在第一位。
            </p>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {team.map((t) => (
                <div key={t.name} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${t.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950">{t.name}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{t.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
              <i className="ri-book-read-line text-primary-500"></i> 使用说明与版权声明
            </h2>
            <ul className="mt-3 flex flex-col gap-3 text-sm leading-relaxed text-foreground-700">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                <span>本站所有影视、资讯内容均为演示虚构数据，仅用于展示产品功能与页面效果，不代表任何真实作品。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                <span>站内「观看」按钮为样式演示，暂不支持在线播放，也不会跳转至任何第三方播放页面。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                <span>收藏与浏览记录保存在你的浏览器本地，清除浏览器数据后将会丢失。</span>
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                <span>本站尊重知识产权，如涉及内容版权问题，欢迎通过下方留言与我们联系。</span>
              </li>
            </ul>
          </section>
        </div>

        <div className="flex flex-col gap-6">
          <ContactForm />

          <section className="rounded-lg border border-background-200 bg-secondary-50 p-5">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-contacts-line text-secondary-600"></i> 联系方式
            </h2>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i> service@yinghua-video.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500"></i> 周一至周日 9:00 - 22:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500"></i> 中国 · 上海市浦东新区影创大厦
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}